'use strict';

var React = require('react');

var SvgMarketsFilledIcon = function SvgMarketsFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 10a7 7 0 0 1 12.584-4.222 2 2 0 0 0-2.327 1.806 3.51 3.51 0 0 0-1.862 2.166h-1.395a1.255 1.255 0 0 1-.764-2.248l.462-.357a.89.89 0 0 0 .347-.707v-.04c0-.747.606-1.353 1.353-1.353h.057c.193 0 .37-.069.509-.184a5.5 5.5 0 0 0-6.945 2.804l1.89 1.89c.378.379.591.892.591 1.427v.518a1 1 0 0 0 1 1 1.5 1.5 0 0 1 1.5 1.5v1.5c.431 0 .85-.05 1.253-.143.028.546.277 1.035.658 1.379a7 7 0 0 1-8.911-6.736Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 7a.75.75 0 0 1 .75.75v.75h.75a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 0 0 1.5h.5a2.25 2.25 0 0 1 .25 4.486v.264a.75.75 0 0 1-1.5 0v-.25h-.75a.75.75 0 0 1 0-1.5h2a.75.75 0 0 0 0-1.5h-.5a2.25 2.25 0 0 1-.25-4.486v-.764a.75.75 0 0 1 .75-.75Z"
  }));
};
SvgMarketsFilledIcon.displayName = "MarketsFilledIcon";

exports.SvgMarketsFilledIcon = SvgMarketsFilledIcon;
